import { css } from "@styled-system/css";

export const actionsClass = css({ display: "flex", gap: "2" });

export const updateBadgeClass = css({
	color: "warning.100",
	fontWeight: "bold",
});
